import type { ApolloCache, ApolloClient, ObservableQuery } from '@apollo/client';
import { GET_GATE_MOVEMENTS_HISTORY } from '../graphql/queries/getGateMovementsHistory';

const HISTORY_QUERY_NAME = 'GetGateMovementsHistory';

type HistoryQueryIdentity = Pick<ObservableQuery, 'queryName' | 'variables'>;

export const shouldRefetchGateMovementsHistory = (query: HistoryQueryIdentity, gateId: string) =>
  query.queryName === HISTORY_QUERY_NAME && query.variables?.gateId === gateId;

export const evictGateMovementsHistory = <TCacheShape extends object>(
  cache: ApolloCache<TCacheShape>,
  gateId: string,
) => {
  const id = cache.identify({ __typename: 'GateMovements', id: gateId });
  return id ? cache.evict({ id, fieldName: 'history' }) : false;
};

export const refreshGateMovementsHistory = async <TCacheShape extends object>(
  client: ApolloClient<TCacheShape>,
  gateId: string,
) => {
  try {
    await client.refetchQueries({
      updateCache(cache) {
        evictGateMovementsHistory(cache, gateId);
      },
      include: [GET_GATE_MOVEMENTS_HISTORY],
      onQueryUpdated(query) {
        return shouldRefetchGateMovementsHistory(query, gateId) ? query.refetch() : false;
      },
    });
  } catch (error) {
    console.error(
      `[GateMessagesSubscription] no se pudo refrescar el historial de ${gateId}`,
      error,
    );
  }
};
